<template>
  <div class="finishExamAuth">
    <!-- <van-nav-bar class="page_nav" title="考试认证" left-arrow @click-left="onClickLeft" :fixed="true" />
    <div class="placeholder_box" style="height:46PX"></div> -->
    <img src="../assets/images/ic-xfcg.png" class="applysuc_img" />
    <p class="tips">您已完成考试提报</p>
    <div class="view_btn" @click="toViewAuthDetail">查看考试认证信息</div>
  </div>
</template>

<script>
export default {
  name: "finishExamAuth",
  data() {
    return {};
  },
  mounted(){
    if (window.history && window.history.pushState) {
      // 往历史记录里面添加一条新的当前页面的url
      history.pushState(null, null, document.URL);
      // 给 popstate 绑定一个方法 监听页面刷新
      window.addEventListener("popstate", this.back, false); //false阻止默认事件
    }
  },
  methods: {
    back(){
      this.$router.push("/saccount");
    },
    toViewAuthDetail(){
      this.$router.push("/rensheMyProfile?type=view");
    }
  }
};
</script>

<style scoped lang="stylus">
.finishExamAuth {
    height: 100vh;
    background-color: #fff;
    text-align:center;
    .applysuc_img {
        width:240px;
        height:240px;
        margin-top:184px;
    }

    .tips {
        font-size: 30px;
        color: #333333;
        line-height: 42px;
        margin-top: 32px;
        margin-bottom: 56px;
        // text-align:center;
    }

    .view_btn {
        display:inline-block;
        width: 400px;
        height: 80px;
        border-radius: 44px;
        border: 1px solid #3760FF;
        font-size: 30px;
        color: #3760FF;
        line-height: 78px;
        text-align: center;
        box-sizing: border-box;
    }
}
</style>

